import React from "react"
import classNames from "classnames"
import {getProductIdentifierFrom} from "../../../helpers/productHelper";
import {
  findProductImageFromQuicklookPreview,
} from "../../../helpers/quicklookPreviewHelper";
import {ProductImageStacType} from "../../../types/product";
import {QuicklookPreviewType} from "../../../types/geoMap";
import QuicklookPreviewImage from "./QuicklookPreviewImage";
import {CartOrderType} from "../../../types/cart";

interface PropsType {
  selectedProducts: ProductImageStacType[],
  productDetails: ProductImageStacType | null,
  quicklookPreviews: QuicklookPreviewType[],
  ordersSubmitted: CartOrderType[],
  onQuicklookPreviewImageClick: (productImage: ProductImageStacType) => {}
}

const QuicklookPreviewImagesList = (props: PropsType) => {
  const {
    selectedProducts,
    quicklookPreviews,
    productDetails,
    onQuicklookPreviewImageClick,
    ordersSubmitted
  } = props;

  const productImageFocusedId = productDetails && getProductIdentifierFrom(productDetails);

  return (
    <>
      {
        quicklookPreviews.map((quicklookPreview) => {
          const productImage = findProductImageFromQuicklookPreview(selectedProducts, ordersSubmitted, quicklookPreview)
          const isFocused = productImageFocusedId && productImageFocusedId === quicklookPreview.productImageId;
          const isSelected = !!productImage && !productImageFocusedId;
          return (
            <QuicklookPreviewImage
              key={`quicklook-preview-${quicklookPreview.productImageId}-${isFocused}-${isSelected}`}
              className={classNames("quicklook-preview-on-map", {
                isFocused,
                isSelected,
              })}
              url={quicklookPreview.url}
              corners={quicklookPreview.corners}
              onClick={() => productImage && onQuicklookPreviewImageClick(productImage)}
            />
          )
        })
      }
    </>
  );
};

export default QuicklookPreviewImagesList;
